export const MANUFACTURING_ORDER_VI = {
  title: 'Quản lý đơn đặt hàng sản xuất',
  pageName: 'Đơn đặt hàng sản xuất',
  all: 'Tất cả',
  created: 'Mới',
  canceled: 'Hủy',
  waiting_finance: 'Chờ kế toán',
  waiting_inbound: 'Chờ nhập hàng',
  inbounded: 'Đã nhập hàng',
  full_paid: 'Hoàn tất thanh toán',
  number: 'Mã đơn đặt hàng sản xuất',
  produceQuantity: 'Số lượng sản xuất',
  producePrice: 'Giá sản xuất',
  producePriceVAT: 'Giá sản xuất (VAT)',
  totalProducePrice: 'Tổng giá sản xuất',
  totalProducePriceVAT: 'Tổng giá sản xuất (VAT)',
  createMOrder: 'Tạo đơn đặt hàng sản xuất',
  paymentTermDays: 'Thời hạn thanh toán',
  deposit: 'Phần trăm đặt cọc',
  totalAmountVAT: 'Thành tiền (VAT)',
  totalAmount: 'Thành tiền',
}
